import { Component, OnInit } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { NgxSmartModalService } from 'ngx-smart-modal';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-buy-product-modal',
  templateUrl: './buy-product-modal.component.html',
  styleUrls: ['./buy-product-modal.component.scss']
})
export class BuyProductModalComponent implements OnInit {

  data;

  constructor(
    private readonly ngxSmartModalService: NgxSmartModalService,
    private gtmService: GoogleTagManagerService,
  ) { }

  ngOnInit(): void {
    this.data = this.ngxSmartModalService.getModalData('buy_product_modal');
    console.log(this.data);
  }

  sendStat(storename) {
    const gtmTag = {
      event: 'addToCart',
      eventCategory: 'Ecommerce',
      eventAction: `redirection::${storename}`,
      eventLabel: `${this.data.name}::${this.data.id}`,
      ecommerce: 'undefined'
    };
    if (environment.ga) {
      this.gtmService.pushTag(gtmTag);
    }
  }

}
